<table class="table">
    <thead>
        <tr>
            <th colspan="2">Bestuurder</th>
            <th width="100">Materieel</th>
            <th colspan="2">Ingepland</th>
        </tr>
    </thead>
    @for (type of types; track type) {
        @if (typeMap.get(type.key)?.length > 0) {
            <thead>
                <tr>
                    <th class="text-center" colspan="5">{{ type.name }}</th>
                </tr>
            </thead>
        }
        @for (entity of typeMap.get(type.key); track entity) {
            <tr>
                <td
                    [class.downlight]="
                        !planningMap.get(entity.id) && usedDrivers.indexOf(entity.driver_user_id) !== -1
                    ">
                    @if (!planningMap.get(entity.id)) {
                        {{ (users | byId: entity.driver_user_id)?.name }}
                    }
                    @for (phe of planningMap.get(entity.id); track phe) {
                        {{ (users | byId: phe.driver_user_id)?.name }}<br />
                    }
                </td>
                <td
                    [cdkContextMenuDisabled]="!(users | byId: entity.driver_user_id)"
                    [cdkContextMenuTriggerFor]="context_menu"
                    (click)="addOrRemoveLeaveFromEntity(entity)"
                    (contextmenu)="contextUserId = entity.driver_user_id">
                    <div class="d-inline-flex flex-column align-center">
                        @if (!planningMap.get(entity.id) && leaveDayUserMap.has(entity.driver_user_id)) {
                            <i
                                class="fa-solid {{
                                    leaveDayUserMap.get(entity.driver_user_id).hourtype | hourtypeIcon
                                }}"
                                [matTooltipShowDelay]="0"
                                matTooltip="{{ leaveDayUserMap.get(entity.driver_user_id)?.hourtype | hourtype }} - {{
                                    leaveDayUserMap.get(entity.driver_user_id)?.comment
                                }}"></i>
                            @if (blockedMap?.has(entity.driver_user_id)) {
                                <i class="fa-regular {{ blockedMap.get(entity.driver_user_id).icon }}"></i>
                            }
                        }
                        @for (phe of planningMap.get(entity.id); track phe) {
                            @if (leaveDayUserMap.has(phe.driver_user_id)) {
                                <i
                                    class="fa-solid {{
                                        leaveDayUserMap.get(phe.driver_user_id).hourtype | hourtypeIcon
                                    }}"
                                    [cdkContextMenuTriggerFor]="context_menu"
                                    [matTooltipShowDelay]="0"
                                    (contextmenu)="contextUserId = phe.driver_user_id"
                                    matTooltip="{{ leaveDayUserMap.get(phe.driver_user_id)?.hourtype | hourtype }} - {{
                                        leaveDayUserMap.get(phe.driver_user_id)?.comment
                                    }}"></i>
                            }
                            @if (blockedMap?.has(phe.driver_user_id)) {
                                <i
                                    class="fa-regular {{ blockedMap.get(phe.driver_user_id).icon }}"
                                    [matTooltip]="blockedMap.get(phe.driver_user_id).description"
                                    [matTooltipShowDelay]="0"></i>
                            }
                        }
                    </div>
                </td>
                <td>
                    <div class="entity-name">
                        {{ entity.name | licensePlate }}
                    </div>
                </td>
                <td>
                    @for (phe of planningMap.get(entity.id); track phe) {
                        {{
                            phe.afas_project_id ??
                                (plannings | byId: phe.planning_id)?.afas_project_id ??
                                (plannings | byId: phe.planning_id)?.worknumber ??
                                '???'
                        }}
                        <br />
                    }
                </td>
                <td>
                    @for (phe of planningMap.get(entity.id); track phe) {
                        @if (Utils.getDateDate(phe.begindate) !== Utils.getDateDate(currentDate)) {
                            {{ phe.begindate | date: 'EEE' }}
                        }
                        {{ phe.begindate | date: 'HH:mm' }}-{{ phe.enddate | date: 'HH:mm' }}<br />
                    }
                </td>
            </tr>
        }
        @if (type.key === 'truck') {
            <thead>
                <tr>
                    <th class="text-center" colspan="5">Niet ingeplande chauffeurs & machinisten</th>
                </tr>
            </thead>
            @for (driver of drivers; track driver) {
                @if (usedDrivers.indexOf(driver.id) === -1) {
                    <tr>
                        <td>
                            {{ driver.name }}
                        </td>
                        <td
                            [cdkContextMenuTriggerFor]="context_menu"
                            (click)="addOrRemoveLeave(driver.id)"
                            (contextmenu)="contextUserId = driver.id">
                            @if (leaveDayUserMap.has(driver.id)) {
                                <i
                                    class="fa-solid {{ leaveDayUserMap.get(driver.id).hourtype | hourtypeIcon }}"
                                    [matTooltipShowDelay]="0"
                                    matTooltip="{{ leaveDayUserMap.get(driver.id)?.hourtype | hourtype }} - {{
                                        leaveDayUserMap.get(driver.id)?.comment
                                    }}"></i>
                            }
                            @if (blockedMap?.has(driver.id)) {
                                <i
                                    class="fa-regular {{ blockedMap.get(driver.id).icon }}"
                                    [matTooltip]="blockedMap.get(driver.id).description"
                                    [matTooltipShowDelay]="0"></i>
                            }
                        </td>
                        <td colspan="3">
                            {{ driver.function }}
                        </td>
                    </tr>
                }
            }
        }
    }
</table>

<ng-template #context_menu>
    <div class="context-menu" cdkMenu>
        <div class="menu-title">
            {{ (users | byId: contextUserId)?.name }}
        </div>
        @if ((users | byId: contextUserId)?.afas_employee_id | afasEmployeeType: 'Z') {
            <button
                class="menu-item"
                [class.active]="currentHourType === RealisationHourtype.zzp_leave"
                (click)="setHourType(RealisationHourtype.zzp_leave)"
                cdkMenuItem>
                <i class="fa-solid {{ RealisationHourtype.zzp_leave | hourtypeIcon }}"></i> ZZP N/b
            </button>
        } @else {
            <button
                class="menu-item"
                [class.active]="currentHourType === RealisationHourtype.frost"
                (click)="setHourType(RealisationHourtype.frost)"
                cdkMenuItem>
                <i class="fa-solid {{ RealisationHourtype.frost | hourtypeIcon }}"></i> Spaaruren
            </button>
            <button
                class="menu-item"
                [class.active]="currentHourType === RealisationHourtype.paid_leave"
                (click)="setHourType(RealisationHourtype.paid_leave)"
                cdkMenuItem>
                <i class="fa-solid {{ RealisationHourtype.paid_leave | hourtypeIcon }}"></i> Doorbetaald verlof
            </button>
            <button
                class="menu-item"
                [class.active]="currentHourType === RealisationHourtype.short_absence"
                (click)="setHourType(RealisationHourtype.short_absence)"
                cdkMenuItem>
                <i class="fa-solid {{ RealisationHourtype.short_absence | hourtypeIcon }}"></i> Kort verzuim
            </button>
            <button
                class="menu-item"
                [class.active]="currentHourType === RealisationHourtype.education"
                (click)="setHourType(RealisationHourtype.education)"
                cdkMenuItem>
                <i class="fa-solid {{ RealisationHourtype.education | hourtypeIcon }}"></i> Scholing
            </button>
            <button
                class="menu-item"
                [class.active]="currentHourType === RealisationHourtype.bank_holiday"
                (click)="setHourType(RealisationHourtype.bank_holiday)"
                cdkMenuItem>
                <i class="fa-solid {{ RealisationHourtype.bank_holiday | hourtypeIcon }}"></i> Feestdag
            </button>
            <button
                class="menu-item"
                [class.active]="currentHourType === RealisationHourtype.sleep"
                (click)="setHourType(RealisationHourtype.sleep)"
                cdkMenuItem>
                <i class="fa-solid {{ RealisationHourtype.sleep | hourtypeIcon }}"></i> Slapen
            </button>
        }
    </div>
</ng-template>
